const config = {
  ENVIRONMENT_NAME: 'dev',
  forwoodId: {
    URL: 'https://id.dev.apps.forwoodsafety.com',
    USER_TOKEN_URL: 'https://ra0s9qg4k9.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://fuerf3fmq4.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.7',
    HOSTNAME: 'https://teams.dev.apps.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.dev.apps.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.dev.apps.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.dev.apps.forwoodsafety.com',
    WEBSOCKET: 'wss://w7wfrjk2l6.execute-api.us-west-2.amazonaws.com/dev'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
